import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { Box } from "@mui/system";
import { CircularProgress, Step, StepButton, Stepper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Period from "./DupliCateBudgetSteps/Period";
import BrandsSelection from "./DupliCateBudgetSteps/BrandsSelection";
import DuplicateBudgetEdit from "./DupliCateBudgetSteps/DuplicateBudgetEdit";
import DbReviewandSave from "./DupliCateBudgetSteps/DbReviewandSave";
import { useSelector } from "react-redux";
import {
  selectUserToken,
  setDisplayErrorSnackBar,
} from "../../../../features/userSlice";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  setDuplicateFrom,
  setDuplicateTo,
  setEditedBudgets,
  // setEditedBudgets,
  // setEditedBudgets,
  setFinalBudgetData,
  setLoading,
  setPostBudgetResponse,
  setSelectedBudgetBrands,
} from "../../../../features/engagementIncentivesSlice";
import {
  setQuery1Data,
  setQuery2Data,
  setQuery3Data,
} from "../../../../features/engagementIncentivesSlice";
import { engagementIncentivesEndPointLogic } from "../../../../logic/PaidTrafficManagement/EngagementIncentives/engagementIncentivesEndPointLogic";
import ResponseDialog from "./DupliCateBudgetSteps/ResponseDialog";
import DoneIcon from "@mui/icons-material/Done";
interface Props {
  open: boolean;
  handleClose: () => void;
}

export default function DupliCateBrandData({ open, handleClose }: Props) {
  const steps = ["Period", "Brands selection", "Edit", "Review & Save"];
  const loading = useSelector(
    (state: any) => state.engagementIncentives.loading
  );
  const { startDate, endDate } = useSelector(
    (state: any) => state.engagementIncentives?.duplicateFrom
  );
  const duplicateTo = useSelector(
    (state: any) => state.engagementIncentives?.duplicateTo
  );
  const editedBudgets = useSelector(
    (state: any) => state.engagementIncentives?.editedBudgets
  );
  const finalBudgetData = useSelector(
    (state: any) => state.engagementIncentives?.finalBudgetData
  );
  const selectedBudgetBrands = useSelector(
    (state: any) => state.engagementIncentives?.selectedBudgetBrands
  );

  const dispatch = useDispatch();
  const QUERY_ID_1 = "5107442887163904";
  const QUERY_ID_2 = "5951867817295872";
  const QUERY_ID_3 = "5388917863874560";
  const [searchParams] = useSearchParams();
  const website_shared_uid: string[] =
    searchParams.get("selectedSites")?.split(",").filter(Boolean) || [];

  const oauthTokenHeader = useSelector(selectUserToken) as any;

  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState<{ [k: number]: boolean }>(
    {}
  );

  const hasError = false; // Define hasError variable Plese use usestate here when develop
  const validateEditedData = () => {
    if (!editedBudgets || editedBudgets.length === 0) {
      return false;
    }

    // Check if all required fields are filled
    return editedBudgets.every((budget: any) => {
      const hasRequiredFields =
        budget.cost_per_qftd !== undefined &&
        budget.cost_per_qftd !== "" &&
        budget.qftd_budget !== undefined &&
        budget.qftd_budget !== "" &&
        Array.isArray(budget.selected_links) &&
        budget.selected_links.length > 0;

      const allLinksValid = budget.selected_links.every(
        (link: any) =>
          link?.link_name !== undefined && link?.link_shared_uid !== undefined
      );

      return hasRequiredFields && allLinksValid;
    });
  };
  const handleNext = async () => {
    if (activeStep === 0) {
      if (!startDate || !endDate) {
        dispatch(
          setDisplayErrorSnackBar({
            message: "Please select both start and end dates.",
            type: "error",
          })
        );
        return;
      }

      dispatch(setLoading(true));
      try {
        const [res1, res2, res3] = await Promise.all([
          engagementIncentivesEndPointLogic.getExequteQueryForDuplicateBudget(
            oauthTokenHeader,
            website_shared_uid,
            startDate,
            endDate,
            QUERY_ID_1
          ),
          engagementIncentivesEndPointLogic.getExequteQueryForDuplicateBudget(
            oauthTokenHeader,
            website_shared_uid,
            startDate,
            endDate,
            QUERY_ID_2
          ),
          engagementIncentivesEndPointLogic.getExequteQueryForDuplicateBudget(
            oauthTokenHeader,
            website_shared_uid,
            startDate,
            endDate,
            QUERY_ID_3
          ),
        ]);
        if (!res1?.query_output?.length) {
          dispatch(
            setDisplayErrorSnackBar({
              message: "No data found for the selected period.",
              type: "error", // or "warning"
            })
          );
          return;
        }

        dispatch(setQuery1Data(res1));
        dispatch(setQuery2Data(res2));
        dispatch(setQuery3Data(res3));

        setCompleted((prev) => ({ ...prev, [activeStep]: true }));
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      } catch (e) {
        dispatch(
          setDisplayErrorSnackBar({
            message: "Failed to fetch data for duplication.",
            type: "error",
          })
        );
      } finally {
        dispatch(setLoading(false));
      }
    } else if (activeStep === 2) {
      // Validate the edit step data before proceeding
      if (!validateEditedData()) {
        dispatch(
          setDisplayErrorSnackBar({
            message: "Please complete all budget and link selections.",
            type: "error",
          })
        );
        return;
      }

      // Save the finalized budget data to Redux for the Review & Save step
      dispatch(setFinalBudgetData(editedBudgets));

      setCompleted((prev) => ({ ...prev, [activeStep]: true }));
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setCompleted((prev) => ({ ...prev, [activeStep]: true }));
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleFinish = async () => {
    if (!finalBudgetData || finalBudgetData.length === 0) {
      dispatch(
        setDisplayErrorSnackBar({
          message: "Final budget data is missing.",
          type: "error",
        })
      );
      return;
    }

    dispatch(setLoading(true));
    try {
      const response =
        await engagementIncentivesEndPointLogic.postDuplicateBudget(
          oauthTokenHeader,
          finalBudgetData
        );
      const status = response?.status;
      const reason = response?.reason || "";
      const data = response?.data || [];

      if (status === 201) {
        dispatch(
          setDisplayErrorSnackBar({
            message: reason || "All budgets created successfully!",
            type: "success",
          })
        );
        setTimeout(() => {
          setActiveStep(0);
          setCompleted({});
        }, 300);
        handleClose();
      } else if (status === 207) {
        // Some succeeded
        dispatch(
          setPostBudgetResponse({
            responseData: data,
            creationStatus: "some",
          })
        );
        handleClose();
      } else if (status === 400) {
        dispatch(
          setDisplayErrorSnackBar({
            message: reason || "No budgets were created.",
            type: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setDisplayErrorSnackBar({
          message: "Error occurred while creating budgets.",
          type: "error",
        })
      );
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleBack = () => {
    setCompleted((prev) => {
      const newCompleted = { ...prev };
      delete newCompleted[activeStep - 1]; // Remove checkmark from previous step
      return newCompleted;
    });
    setActiveStep((prevActiveStep) => {
      const newStep = Math.max(prevActiveStep - 1, 0);

      // If navigating back to step 0 (Period), clear the dates
      if (newStep === 0) {
        dispatch(setDuplicateFrom({ startDate: null, endDate: null }));
        // dispatch(setDuplicateTo(null));
        dispatch(setSelectedBudgetBrands([]));
      }
      if (activeStep === 2) {
        dispatch(setEditedBudgets([])); // Clear edited budgets
      }

      return newStep;
    });
  };

  const handleStep = (step: number) => {
    if (step > activeStep || !completed[step]) return; // prevent forward step jump
    setActiveStep(step);
  };

  // const handleFinish = () => {
  //   setCompleted((prev) => ({ ...prev, [activeStep]: true })); // Mark final step as completed
  //   handleClose(); // Close the dialog
  //   setTimeout(() => {
  //     setActiveStep(0); // Reset the stepper after closing
  //     setCompleted({}); // Clear completed steps
  //   }, 300); // Small delay ensures smooth closing before resetting
  // };

  React.useEffect(() => {
    if (!open) {
      setActiveStep(0);
      setCompleted({});

      dispatch(setDuplicateFrom({ startDate: null, endDate: null }));
      dispatch(setDuplicateTo(null));
      dispatch(setFinalBudgetData([]));
      dispatch(setQuery1Data(null));
      dispatch(setQuery2Data(null));
      dispatch(setQuery3Data(null));
      dispatch(setSelectedBudgetBrands([]));
      // dispatch(setEditedBudgets([])); // If needed
    }
  }, [open, dispatch]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Box>
          <DialogTitle id="alert-dialog-title">
            {"Duplicate Budget"}
          </DialogTitle>
          <DialogContent>
            <Box sx={{ width: "100%", overflow: "hidden" }}>
              <Stepper nonLinear activeStep={activeStep}>
                {steps.map((label, index) => (
                  <Step key={label} completed={completed[index]}>
                    <StepButton
                      onClick={() => handleStep(index)}
                      sx={{
                        "& .MuiStepIcon-root": {
                          color:
                            label === "Save" && hasError
                              ? "rgba(211, 47, 47, 1) !important" // Red if there's an error
                              : activeStep === index || completed[index]
                              ? "rgba(156, 39, 176, 1) !important"
                              : "rgba(0, 0, 0, 0.38) !important",
                        },
                        "&.Mui-active .MuiStepIcon-root, &.Mui-completed .MuiStepIcon-root":
                          {
                            color:
                              label === "Save" && hasError
                                ? "rgba(211, 47, 47, 1) !important" // Keep red if error exists
                                : "rgba(156, 39, 176, 1) !important",
                          },
                      }}
                    >
                      {label}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
            </Box>

            {/* Conditional rendering based on active step */}
            {activeStep === 0 && (
              <Box>
                <Period />
              </Box>
            )}

            {activeStep === 1 && (
              <Box>
                <BrandsSelection />
              </Box>
            )}

            {activeStep === 2 && (
              <Box>
                <>
                  <DuplicateBudgetEdit />
                </>
              </Box>
            )}

            {activeStep === 3 && (
              <Box>
                <>
                  <DbReviewandSave />
                </>
              </Box>
            )}
          </DialogContent>

          <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
            <Button
              onClick={handleClose} // Function to close the dialog
              color="secondary"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleBack}
              variant="outlined"
              color="secondary"
              sx={activeStep === 0 ? { display: "none" } : {}}
              startIcon={<ArrowBackIcon />}
            >
              Back
            </Button>
            <Button
              onClick={
                activeStep === steps.length - 1 ? handleFinish : handleNext
              }
              data-tracker="368"
              color="secondary"
              variant="contained"
              disabled={
                loading ||
                (activeStep === 0 && (!startDate || !endDate)) ||
                (activeStep === 0 && !duplicateTo) ||
                (activeStep === 1 && !selectedBudgetBrands.length) ||
                (activeStep === 2 && !validateEditedData())
              }
              endIcon={
                loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : activeStep === steps.length - 1 ? (
                  <DoneIcon />
                ) : (
                  <ArrowForwardOutlinedIcon />
                )
              }
            >
              {loading
                ? "Loading..."
                : activeStep === steps.length - 1
                ? "Duplicate"
                : "Next"}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
      <ResponseDialog />
    </>
  );
}
